/**
 * Casa Vincenzo — PDP sticky add to cart.
 *
 * Ported from the live Helm v3 11.08 theme. The theme's own
 * <sticky-add-to-cart> keeps doing the work (it puppets the main product form,
 * so quantity, variant and error handling stay intact). This module adds the
 * live theme's behaviour on top: once something has been added to the cart the
 * sticky button turns into "Continue to checkout" and goes straight to checkout.
 */

import { StandardEvents } from '@shopify/events';

(function () {
  if (window.__helmSticky) return;
  window.__helmSticky = true;

  const LANG = (document.documentElement.getAttribute('lang') || 'en').slice(0, 2).toLowerCase();
  const IS_AR = LANG === 'ar';

  const TEXT = IS_AR ? { checkout: 'متابعة إلى الدفع' } : { checkout: 'Continue to checkout' };

  let addedToCart = false;

  function stickyButton() {
    return document.querySelector('.sticky-add-to-cart__button');
  }

  function labelNode(button) {
    if (!button) return null;
    const content = button.querySelector('.add-to-cart-text__content');
    if (!content) return null;
    return content.querySelector('span') || content;
  }

  function checkoutUrl() {
    const root =
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.replace(/\/$/, '') + '/checkout';
  }

  function convert(button) {
    if (!button || button.getAttribute('data-checkout-mode') === '1') return;

    button.setAttribute('data-checkout-mode', '1');
    button.removeAttribute('disabled');

    const label = labelNode(button);
    if (label) label.textContent = TEXT.checkout;

    // The theme appends a " (n)" quantity hint; it makes no sense on a checkout link.
    const quantity = button.querySelector('[ref="quantityDisplay"]');
    if (quantity) quantity.style.display = 'none';

    // The icon is an "add to cart" trolley — drop it in checkout mode.
    const icon = button.querySelector('.add-to-cart-text .svg-wrapper');
    if (icon) icon.style.display = 'none';
  }

  function applyMode() {
    if (!addedToCart) return;
    convert(stickyButton());
  }

  // Runs in the capture phase so it beats the component's own click handler.
  document.addEventListener(
    'click',
    (event) => {
      const target = event.target;
      if (!target || typeof target.closest !== 'function') return;

      const button = target.closest('.sticky-add-to-cart__button[data-checkout-mode="1"]');
      if (!button) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      window.location.href = checkoutUrl();
    },
    true
  );

  document.addEventListener(StandardEvents.cartLinesUpdate, async (event) => {
    const action = event.action || (event.detail && event.detail.action);
    if (action !== 'add') return;

    try {
      const result = await event.promise;
      if (result && result.detail && result.detail.didError) return;
    } catch (error) {
      return;
    }

    addedToCart = true;
    window.setTimeout(applyMode, 60);
  });

  // The sticky bar is re-rendered on variant change, which would restore the
  // original label; re-apply checkout mode whenever the DOM changes.
  function observe() {
    if (!('MutationObserver' in window)) return;
    new MutationObserver(applyMode).observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observe, { once: true });
  } else {
    observe();
  }
})();
